import { BLOG_PAGE } from '~/lib/fetch-links'
import PrismicJS, { prismic } from '~/lib/prismic'
import { PRISMIC_TYPES } from '~/lib/prismic-types'

import { getCMSLang } from '~/utils/locales'

interface GetArticlesArgs {
  pageSize?: number
  page?: string | string[] | number
  locale?: string
  categoryIds?: string[]
  previewRef?: string
}

export async function getBlogArticles({
  pageSize = 11,
  page = 1,
  categoryIds = [],
  locale,
  previewRef,
}: GetArticlesArgs) {
  const lang = getCMSLang(locale)

  return await prismic.get({
    filters: [
      PrismicJS.filter.at('document.type', PRISMIC_TYPES.ARTICLE),
      ...(categoryIds?.length > 0
        ? [
            PrismicJS.filter.any(
              `my.${PRISMIC_TYPES.ARTICLE}.category`,
              categoryIds,
            ),
          ]
        : []),
    ],
    lang,
    ref: previewRef,
    page: Array.isArray(page) ? parseInt(page[0]) : +page,
    pageSize,
    orderings: {
      field: 'document.first_publication_date',
      direction: 'desc',
    },
    fetchLinks: BLOG_PAGE,
  })
}
